module.exports = __webpack_public_path__ + "static/media/devops-hero.9d9ab8e7.jpg";